import { clone } from '@jkhy/frontend-utils/functions';
import { TransferProductFeatureModelDto } from '@treasury/api/bo/overrides';
import { FeatureApiType } from '../../types/product-feature.enum';
import { AccountPermission } from '../account-permission.entity';
import { CompanyProductFeature } from './company-product-feature.entity';

const nullTransferProductFeatureModelDto: TransferProductFeatureModelDto = {
    accountPermissions: [],
    id: 0,
    productUniqueId: '',
    type: FeatureApiType.Transfer,
    isConfigurable: true,
};

export class TransferProductFeature extends CompanyProductFeature<TransferProductFeatureModelDto> {
    constructor(dto: TransferProductFeatureModelDto = clone(nullTransferProductFeatureModelDto)) {
        super(dto);
        this.accountPermissions = dto.accountPermissions.map(
            permission => new AccountPermission(permission)
        );
    }

    public get accountPermissions() {
        return this.dto.accountPermissions.map(permission => new AccountPermission(permission));
    }

    public set accountPermissions(permissions: AccountPermission[]) {
        this.dto.accountPermissions = permissions.map(permission => permission.toDto());
    }

    public get dailyLimit() {
        return this.dto.dailyLimit;
    }

    public set dailyLimit(value: number | undefined) {
        this.dto.dailyLimit = value;
    }

    public get approval() {
        if (this.dto.approval === 'None') {
            return 0;
        }
        if (this.dto.approval === undefined) {
            return undefined;
        }
        return Number(this.dto.approval);
    }

    public set approval(value: number | undefined) {
        this.dto.approval = value === 0 ? 'None' : value;
    }

    public get templateApproval() {
        if (this.dto.templateApproval === 'None') {
            return 0;
        }
        if (this.dto.templateApproval === undefined) {
            return undefined;
        }
        return Number(this.dto.templateApproval);
    }

    public set templateApproval(value: number | undefined) {
        this.dto.templateApproval = value === 0 ? 'None' : value;
    }

    public get allowLoanPaymentPastDue() {
        return this.dto.allowLoanPaymentPastDue ?? false;
    }

    public set allowLoanPaymentPastDue(value: boolean) {
        this.dto.allowLoanPaymentPastDue = value;
    }

    public get accounts() {
        return this.dto.accounts;
    }
}
